// extracted by mini-css-extract-plugin
export default {"card":"Q3-z"};